"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
// This is a dummy component that can be replaced to inject more side panel sub panels into the side bar
function CustomPanelsFactory() {
  var CustomPanels = function CustomPanels(props) {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  };

  CustomPanels.defaultProps = {
    // provide a list of additional panels
    panels: [// {
      //   id: 'rocket',
      //   label: 'Rocket',
      //   iconComponent: Icons.Rocket
      // },
      // {
      //   id: 'chart',
      //   label: 'Chart',
      //   iconComponent: Icons.LineChart
      // }
    ],
    // prop selector from side panel props
    getProps: function getProps(sidePanelProps) {
      return {};
    }
  };
  return CustomPanels;
}

var _default = CustomPanelsFactory;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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